import React, { useState } from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { fmtDate } from "@/lib/format";

const COL = 44;
const WD = ["Κυ", "Δε", "Τρ", "Τε", "Πε", "Πα", "Σα"];
const localDate = (iso) => new Date(Number(iso.slice(0, 4)), Number(iso.slice(5, 7)) - 1, Number(iso.slice(8, 10)));
const localToday = () => { const n = new Date(); return `${n.getFullYear()}-${String(n.getMonth() + 1).padStart(2, "0")}-${String(n.getDate()).padStart(2, "0")}`; };
const NAME_W = "w-[100px] sm:w-[160px]";

const Bar = ({ b, days, onClick }) => {
  const first = days[0].date;
  const lastDay = days[days.length - 1].date;
  const idx = (s) => Math.round((localDate(s) - localDate(first)) / 86400000);
  const s = Math.max(idx(b.fromd), 0);
  const e = Math.min(idx(b.tod), days.length);
  const startsBefore = b.fromd < first;
  const endsAfter = b.tod > lastDay;
  const left = s * COL + (startsBefore ? 0 : COL / 2);
  const width = Math.max((e - s) * COL - (startsBefore ? 0 : COL / 2) + (endsAfter ? COL : COL / 2), 14);
  return (
    <button onClick={() => onClick(b)} data-testid={`plan-bar-${b.reservation_id}-${b.villa || "na"}`}
      className="absolute top-1.5 h-8 rounded-lg bg-[#6E7A63] text-white text-[11px] px-2 text-left truncate shadow-sm hover:bg-[#5B6651] transition-colors"
      style={{ left, width }} title={`${b.guest_name} · ${b.pax} άτ · ${fmtDate(b.fromd)}–${fmtDate(b.tod)}`}>
      {b.guest_name} · {b.pax}
    </button>
  );
};

export const PlanGrid = ({ data, OccCell }) => {
  const [sel, setSel] = useState(null);
  const days = data?.days || [];
  if (!days.length) return null;
  const today = localToday();
  const rows = [...data.villas, ...(data.bars.some((b) => !b.villa) ? [""] : [])];
  return (
    <div className="overflow-x-auto" data-testid="plan-grid">
      <div style={{ minWidth: 160 + days.length * COL }}>
        <div className="flex sticky top-0 bg-[#45423C] text-white">
          <div className={`${NAME_W} shrink-0 px-3 py-2 text-[10px] uppercase tracking-wider text-white/70 sticky left-0 bg-[#45423C] z-10`}>Βίλα</div>
          {days.map((d) => {
            const dt = localDate(d.date);
            const we = dt.getDay() === 0 || dt.getDay() === 6;
            return (
              <div key={d.date} className={`shrink-0 text-center py-1.5 ${we ? "bg-[#56524A]" : ""} ${d.date === today ? "ring-2 ring-inset ring-[#C86235]" : ""}`} style={{ width: COL }}>
                <div className="text-[9px] text-white/60">{WD[dt.getDay()]}</div>
                <div className="text-xs font-semibold tabular">{d.date.slice(8)}</div>
              </div>
            );
          })}
        </div>
        <div className="flex border-b border-[#E3DED4] bg-[#F7F5F1]" data-testid="plan-occ-row">
          <div className={`${NAME_W} shrink-0 px-3 py-2 text-[11px] font-semibold text-[#45423C] sticky left-0 bg-[#F7F5F1] z-10`}>Πληρότητα · άτομα</div>
          {days.map((d) => <div key={d.date} className="shrink-0 p-0.5" style={{ width: COL }}><OccCell d={d} /></div>)}
        </div>
        {rows.map((v) => (
          <div key={v || "na"} className="flex border-b border-[#EFEBE3]" data-testid={`plan-row-${v || "na"}`}>
            <div className={`${NAME_W} shrink-0 px-3 py-3 text-sm font-medium text-[#45423C] sticky left-0 bg-white z-10 truncate`}>{v || "Χωρίς ανάθεση βίλας"}</div>
            <div className="relative" style={{ width: days.length * COL, height: 44 }}>
              {days.map((d, i) => <div key={d.date} className={`absolute top-0 bottom-0 border-l border-[#F1EDE6] ${d.date === today ? "bg-[#C86235]/5" : ""}`} style={{ left: i * COL, width: COL }} />)}
              {data.bars.filter((b) => b.villa === v).map((b) => <Bar key={`${b.reservation_id}-${b.fromd}-${b.villa}`} b={b} days={days} onClick={setSel} />)}
            </div>
          </div>
        ))}
      </div>
      <Dialog open={!!sel} onOpenChange={(o) => !o && setSel(null)}>
        <DialogContent className="max-w-sm" data-testid="plan-bar-dialog">
          <DialogHeader>
            <DialogTitle>{sel?.guest_name}</DialogTitle>
            <DialogDescription>Κράτηση {sel?.code}</DialogDescription>
          </DialogHeader>
          {sel && (
            <dl className="grid grid-cols-2 gap-y-2 text-sm">
              <dt className="text-[#6F6A60]">Βίλα</dt><dd>{sel.villa || sel.room_type}</dd>
              <dt className="text-[#6F6A60]">Άφιξη</dt><dd>{fmtDate(sel.fromd)}</dd>
              <dt className="text-[#6F6A60]">Αναχώρηση</dt><dd>{fmtDate(sel.tod)}</dd>
              <dt className="text-[#6F6A60]">Άτομα</dt><dd>{sel.pax}</dd>
              <dt className="text-[#6F6A60]">Κατάσταση</dt><dd>{sel.status}</dd>
              <dt className="text-[#6F6A60]">Πηγή</dt><dd>{sel.source || "—"}</dd>
            </dl>
          )}
        </DialogContent>
      </Dialog>
    </div>
  );
};
